export default "__VITE_ASSET__19b3a6f9__"